import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useProductBySlug } from "@/hooks/useProductData";
import FlipbookViewer from "./components/FlipbookViewer";

const FlipbookSkeleton = () => (
  <div className="min-h-screen bg-[#0f172a] flex items-center justify-center">
    <div className="text-center space-y-4">
      <div className="w-16 h-16 rounded-2xl bg-white/10 animate-pulse mx-auto" />
      <div className="h-4 w-48 bg-white/10 rounded-lg animate-pulse mx-auto" />
      <div className="h-3 w-32 bg-white/10 rounded-lg animate-pulse mx-auto" />
    </div>
  </div>
);

const FlipbookPage = () => {
  const { companySlug, productSlug } = useParams<{
    companySlug: string;
    productSlug: string;
  }>();
  const { product, loading } = useProductBySlug(companySlug, productSlug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [companySlug, productSlug]);

  if (loading) return <FlipbookSkeleton />;

  if (!product) {
    return (
      <div className="min-h-screen bg-[#0f172a] flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
            <i className="ri-error-warning-line text-5xl text-white/20" />
          </div>
          <p className="text-white/60 text-lg font-medium mb-2">
            Không tìm thấy sản phẩm
          </p>
          <p className="text-white/40 text-sm">
            Flipbook không tồn tại hoặc đã bị xoá.
          </p>
        </div>
      </div>
    );
  }

  return <FlipbookViewer product={product} />;
};

export default FlipbookPage;